'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var math = require('../utils/math.js');
var Box = require('@material-ui/core/Box');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Box__default = /*#__PURE__*/_interopDefaultLegacy(Box);

var _excluded = ["children", "aspectRatio"];
/**
 * Div container with a fixed aspect ratio.
 */

function AspectRatioBox(_ref) {
  var {
    children,
    aspectRatio = 1
  } = _ref,
      rest = _rollupPluginBabelHelpers.objectWithoutProperties(_ref, _excluded);

  var paddingTop = React__namespace.useMemo(() => {
    var inverseAspectRatio = math.safeDivide(1, aspectRatio);
    return "".concat(inverseAspectRatio * 100, "%");
  }, [aspectRatio]);
  return /*#__PURE__*/React__namespace.createElement(Box__default['default'], {
    sx: {
      overflow: 'hidden',
      position: 'relative',
      width: '100%',
      height: 0,
      paddingTop
    }
  }, /*#__PURE__*/React__namespace.createElement(Box__default['default'], _rollupPluginBabelHelpers['extends']({}, rest, {
    sx: _rollupPluginBabelHelpers.objectSpread2({
      position: 'absolute',
      height: '100%',
      width: '100%',
      top: 0,
      left: 0
    }, rest.sx)
  }), children));
}
AspectRatioBox.propTypes = {
  /** Decimal value of the width by height. E.g. 16/9 */
  aspectRatio: index.number,

  /** Content of the div. */
  children: index.node
};

exports.AspectRatioBox = AspectRatioBox;
